import { useState } from "react";
import CustomModal from "../Modal/CustomModal";
import previes from "../../assets/images/Reference Form-filled.jpeg";
const FoemPreview = () => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <span style={{cursor:"pointer",fontWeight:"800",color:"#b59745"}} onClick={handleOpenModal}> See preview</span>
      <CustomModal
        show={showModal}
        onClickClose={handleCloseModal}
        modalTitle={""}
      >
        <img className="img-fluid" src={previes} alt="" />
      </CustomModal>
    </>
  );
};

export default FoemPreview;
